<!-- login form -->
<ion-grid>
  <ion-row
    class="ion-align-items-center"
    [ngStyle]="{ height: showFullPage ? '80vh' : 'unset' }"
  >
    <ion-col>
      @if (form) {
        <form
          [formGroup]="form"
          [ngClass]="{ submitted: formSubmitted }"
          (submit)="onSubmit()"
        >
          <ion-grid>
            <!-- logo -->
            <ion-row>
              <ion-col
                [offsetXs]="sizeXSLeft"
                [offsetMd]="sizeMDLeft"
                [attr.size-xs]="sizeXSMid"
                [attr.size-md]="sizeMDMid"
                class="ion-no-padding"
              >
                <ion-item class="ion-no-padding" lines="none">
                  <img src="{{ _logo }}" alt="avatar" class="img-responsive" />
                </ion-item>
              </ion-col>
            </ion-row>

            <!-- username -->
            <ion-row>
              <ion-col
                [offsetXs]="sizeXSLeft"
                [offsetMd]="sizeMDLeft"
                [attr.size-xs]="sizeXSMid"
                [attr.size-md]="sizeMDMid"
                class="ion-no-padding"
              >
                <ion-input
                  margin-vertical
                  class="change-property-box hide-required"
                  autocomplete="email"
                  label="{{ 'login_email' | translate }}"
                  type="text"
                  formControlName="username"
                ></ion-input>
              </ion-col>
            </ion-row>

            <!-- password -->
            <ion-row>
              <ion-col
                [offsetXs]="sizeXSLeft"
                [offsetMd]="sizeMDLeft"
                [attr.size-xs]="sizeXSMid"
                [attr.size-md]="sizeMDMid"
                class="ion-no-padding"
              >
                <ion-input
                  class="change-property-box hide-required"
                  autocomplete="current-password"
                  label="{{ 'login_password' | translate }}"
                  type="password"
                  formControlName="password"
                  (change)="pwdChange($event)"
                ></ion-input>
              </ion-col>
            </ion-row>

            <!-- login button -->
            <ion-row>
              <ion-col
                [offsetXs]="sizeXSLeft"
                [offsetMd]="sizeMDLeft"
                [attr.size-xs]="sizeXSMid"
                [attr.size-md]="sizeMDMid"
                class="ion-no-padding"
              >
                <ion-button
                  margin-top
                  class="ga_button_login"
                  expand="block"
                  size="default"
                  type="submit"
                  >{{ 'login_login' | translate }}</ion-button
                >
              </ion-col>
            </ion-row>

            <!-- forgot password -->
            @if (showForgotPassword) {
              <ion-row>
                <ion-col
                  [offsetXs]="sizeXSLeft"
                  [offsetMd]="sizeMDLeft"
                  [attr.size-xs]="sizeXSMid"
                  [attr.size-md]="sizeMDMid"
                  class="ion-no-padding"
                >
                  <ion-button
                    fill="clear"
                    expand="block"
                    (click)="onForgotPasswordClicked()"
                    class="ga_button_forgotpassword"
                  >
                    {{ 'login_forgotPassword' | translate }}
                  </ion-button>
                </ion-col>
              </ion-row>
            }

            <!-- register link -->
            @if (showRegister) {
              <ion-row>
                <ion-col
                  [offsetXs]="sizeXSLeft"
                  [offsetMd]="sizeMDLeft"
                  [attr.size-xs]="sizeXSMid"
                  [attr.size-md]="sizeMDMid"
                  class="ion-no-padding"
                >
                  <ion-button
                    color="medium"
                    expand="block"
                    class="ga_button_register"
                    (click)="onRegisterClicked()"
                    fill="outline"
                    >{{ 'login_register' | translate }}</ion-button
                  >
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </form>
      }
    </ion-col>
  </ion-row>
</ion-grid>
